import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'

import { SettingsService } from '@app/services/settings.service'

import * as fromFeature from '.'

@Injectable()
export class SettingsEffects {
  private readonly actions$ = inject(Actions)
  private readonly settingsService = inject(SettingsService)

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromFeature.Actions.load),
      switchMap(() =>
        from(this.settingsService.getUser()).pipe(
          map(({ user, dict }) => fromFeature.Actions.loadSuccess({ user, dict })),
          catchError(error => of(fromFeature.Actions.loadFailure({ error }))),
        ),
      ),
    ),
  )
}
